import PhoneIndex from '@/pages/h5/Index';
import PcIndex from '@/pages/pc/Index';
const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
export default () => {
  return isMobileDevice() ? <PhoneIndex /> : <PcIndex />;
};
